<!-- TM-1000001963: bind to precomputed topbarBackground (set in ngOnInit / theme apply) to avoid NG0100 -->
<div class="layout-topbar shadow-4 h-auto align-items-center"
     [style.background]="topbarBackground">

    <!-- Normal Without Overlay  -->
    <ng-container>
        <!-- Logo And Search -->
        <div class="layout-topbar-left" style="background: transparent">
            <!-- Overlay  -->
            <ng-container *ngIf="displayStack && displayStack.length">
                <div class="flex justify-content-between align-items-center px-3 py-2 w-full">
                    <div class="topbar flex gap-3">
<!--                        <ng-container *ngIf="objectLabel">-->
<!--                            <span class="overlay-item" (click)="onNavigateToMainPage()">{{ objectLabel }}</span>-->
<!--                            <span> | </span>-->
<!--                        </ng-container>-->
                        <ng-container *ngFor="let entry of displayStack; let i = index">
                            <div class="flex align-items-center border-round-md text-700 p-1"
                                 [ngClass]="i == activeOverlayIndex ? 'bg-primary-50' : 'surface-50'">
                <span (click)="toggleOverlay(i)"
                      class="overlay-item">
            <!--        displayStack-->
                    {{ entry['label'] }}
                </span>
                                <p-button [icon]="'fa fa-xmark'" styleClass="p-button-text w-1rem h-1rem"
                                          (click)="handleRemoveItem(i)"></p-button>
                            </div>
                            <!--                <span *ngIf="i < displayStack.length - 1"> | </span>-->
                        </ng-container>
                    </div>
                    <p-button styleClass="hover:surface-200 text-600 surface-50" icon="fa fa-times text-xl"
                              (click)="onNavigateToMainPage()"></p-button>
                </div>
            </ng-container>


            <ng-container *ngIf="!displayStack || !displayStack.length">
                <a class="layout-topbar-logo w-14rem cursor" (click)="handleHomePageNavigation()">
                    <!-- The <img> must stay in the DOM even without a logo: the UI settings and the
                         layout config write the logo source straight to #app-logo. It is hidden
                         instead of removed, so no broken image is rendered. -->
                    <img id="app-logo" [attr.src]="tenantLogo || null" alt="Mandantenlogo" class="p-3"
                         style="height: 4.25rem" [class.hidden]="!tenantLogo">
                    @if (!tenantLogo) {
                        <span class="p-3 text-xl font-semibold text-color">{{ tenantName || 'Alpha' }}</span>
                    }
                </a>

                <a class="layout-topbar-mobile-button" (click)="appMain.onTopbarMobileButtonClick($event)" pRipple>
                    <i class="pi pi-ellipsis-v fs-large"></i>
                </a>
            </ng-container>
        </div>

        <div class="layout-topbar-right pl-2" [ngClass]="{'layout-topbar-mobile-active': appMain.mobileTopbarActive}">
            <div class="layout-topbar-actions-left gap-3">
                <ng-container *ngIf="!displayStack || !displayStack.length">
                    <mvs-command-menu-search></mvs-command-menu-search>

                </ng-container>
            </div>

            <!-- Right Menu Items (Always Display) -->
            <div class="layout-topbar-actions-right">
                <ul class="layout-topbar-items">

                    <li class="layout-topbar-item layout-search-item mr-2">


                        <mvs-pc-header-call-active></mvs-pc-header-call-active>

                    </li>
                    <li class="layout-topbar-item">
                        <am-agent-main-active-objects></am-agent-main-active-objects>
                    </li>


                    <li class="layout-topbar-item incoming-call">
                        <a pRipple class="layout-topbar-action rounded-circle"
                           routerLink="/pc/incomingCall">
                            <i class="fa-regular fa-phone text-2xl text-500 dark-topbar-icon"></i>
                        </a>
                    </li>

                    <li class="layout-topbar-item">
                        <am-agent-active-objects></am-agent-active-objects>
                    </li>


                    <li (click)="handleNavigationToProfile()" class="cursor align-self-center">
                        <img class="h-2rem w-2rem border-circle mx-2"
                             [src]="profilePicture ?? 'assets/layout/images/blank_user.png'"/>
                    </li>

                    <li class="layout-topbar-item incoming-call" (click)="handleLogoutUser()">
                        <a pRipple class="layout-topbar-action rounded-circle">
                            <i class="fa-regular fa-power-off text-2xl text-500 dark-topbar-icon"></i>
                        </a>
                    </li>

                    <!-- Spring Batch Job Indicator (service-driven) -->
                    <li class="layout-topbar-item">
                        <jb-spring-batch-indicator
                            [useService]="true"
                            overlayPosition="left">
                        </jb-spring-batch-indicator>
                    </li>

                    <li class="layout-topbar-item">
                        <a class="layout-topbar-action rounded-circle justify-content-center"
                           (click)="appMain.onRightMenuButtonClick($event)" pRipple>
                            <i class="fa-light fa-bars fs-large dark-topbar-icon"></i>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </ng-container>

</div>
